import { z } from 'zod';
import { EbpCaseProgressColor } from '../enums/EbpCaseProgressColor';

const progressColorSchema = z.enum(EbpCaseProgressColor);

export const EbpCaseProgressSchema = z.object({
  stage1: progressColorSchema,
  stage2: progressColorSchema,
  stage3: progressColorSchema,
  stage4: progressColorSchema,
  stage5: progressColorSchema,
});

export type EbpCaseProgress = z.infer<typeof EbpCaseProgressSchema>;

export const DefaultEbpCaseProgress = {
  stage1: EbpCaseProgressColor.Grey,
  stage2: EbpCaseProgressColor.Grey,
  stage3: EbpCaseProgressColor.Grey,
  stage4: EbpCaseProgressColor.Grey,
  stage5: EbpCaseProgressColor.Grey,
} satisfies EbpCaseProgress;
